/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-script-url */
import * as HERBUI from "react-bootstrap";
import { BiArrowFromLeft } from "react-icons/bi";
import { LOGIN_DOMAIN } from "../Api/APIURLS";
var createGuest = require('cross-domain-storage/guest');
const DashboardCardBudget = (props) => {
  const { title, url, module,serviceId } = props;
  function redirectUrl(urlValue, moduleType) {
    let mainAppguest = createGuest(LOGIN_DOMAIN);
    localStorage.setItem('url', JSON.stringify(urlValue))
    mainAppguest.set('url', JSON.stringify(urlValue), function (error, data) {
      // foo is now set to 'bar'
    });
    mainAppguest.set('serviceId', JSON.stringify(serviceId), function (error, data) {
      // foo is now set to 'bar'
    });
    let splitUrl = url.split("/")[3]
    if (splitUrl === "nayam") {
          window.open(urlValue, '_blank');
    }
    else {
      window.location.href = urlValue
    } 
  }
  return (
    <HERBUI.Col xs={12} sm={12} md={3} lg={3} xl={3}>
      <div className="cards card1 bg-white mb-4">
        <div className="cards-body">
          <a onClick={() => redirectUrl(url, module)} href='javascript:void(0)'>
            <div className="go-corner"> <div className="go-arrow"> <BiArrowFromLeft className="cardico icon-size-header2" /> </div> </div>
            <h5 className="cards_title float-start"  >{title}</h5>  </a>
        </div>
      </div>
    </HERBUI.Col>
  );
};

export default DashboardCardBudget;
